import React, { useState } from 'react'
import { useSetRecoilState } from 'recoil'
import { useForm } from 'react-hook-form'
import { Link, navigate } from 'gatsby'
import { Col, Row, Stack } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { TextInput, IconButton } from '/src/components/common'
import { postRequest, getRequest } from '/src/httpClient'
import { userStoreState, getStore } from '/src/components/commerce/store/storeSelectorState'
import { cartState, cartCountState, getCart } from '/src/hooks/useCart'
import { userState } from '/src/hooks/useUser'

import './login_form.scss'

export const LoginForm = () => {
  const { register, formState: { errors }, setError, handleSubmit } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const setUserState = useSetRecoilState(userState)
  const setCartState = useSetRecoilState(cartState)
  const setCartCount = useSetRecoilState(cartCountState)
  const setStore = useSetRecoilState(userStoreState)

  const onSubmit = (data) => {
    setIsLoading(true)
    postRequest('/api/user/login', {
      name: data.name,
      pass: data.pass
    }).then(res => {
      if (!res) {
        setIsLoading(false)
        setError('name', { type: 'custom', message: 'Sorry, unrecognized username or password.' })
      }
      else {
        getRequest('/api/user', new AbortController()).then(userRes => {
          setCartState(false)
          setUserState(userRes)

          getStore().then(storeRes => {
            setStore(storeRes)
          })

          getCart().then(cartRes => {
            if (!cartRes) {
              navigate('/user')
              return
            }

            const { order_items } = cartRes.relationships
            setCartState(cartRes)

            let cartQuantity = 0
            if (order_items.data.length !== 0) {
              cartQuantity = order_items.data.map(({ attributes }) => {
                return attributes.quantity
              }).reduce(
                (a, c) => a + parseInt(c),
                0
              )
            }
            setCartCount(cartQuantity)

            if (!cartRes || cartRes === null || (cartRes && order_items.data.length === 0)) {
              navigate('/user')
            }
            else {
              navigate('/cart')
            }

            setIsLoading(false)
          })
        })
      }
    })
  }

  return (
    <div className="login-form-container">
      <form id="login-form" onSubmit={handleSubmit(onSubmit)}>
        <Row className="mb-4">
          <Col sm={12}>
            <TextInput label="Email" type="text" error={errors.name} register={register('name', {
              required: true,
              pattern: {
                value: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
                message: 'Please provide a valid email address'
              }
            })} />
          </Col>
          <Col sm={12}>
            <TextInput label="Password" type="password" error={errors.name} register={register('pass', {
              required: true
            })} />
          </Col>
        </Row>
        <Row>
          <Stack direction="horizontal" gap={5}>
            <IconButton type="submit" icon={faArrowRight} disabled={isLoading}>
              {isLoading ? 'Checking...' : 'Login'}
            </IconButton>
            <Link className="link forgot-password-link" to="/user/password">
              <FontAwesomeIcon icon={faQuestionCircle} />
              Forgot Password
            </Link>
          </Stack>
        </Row>
      </form>
    </div>
  )
}

export default LoginForm